import BrandOfTheWeekView from '@/modules/HomePage/components/BrandOfTheWeek/BrandOfTheWeekView';
import useHomepageContext from '@/modules/HomePage/HomePageContext';

const BrandOfTheWeek = () => {
  const { brandOfTheWeek } = useHomepageContext();

  if (!brandOfTheWeek?.brand || !brandOfTheWeek?.artworks) return null;

  return <BrandOfTheWeekView artworks={brandOfTheWeek.artworks} brand={brandOfTheWeek.brand} />;
};

export default BrandOfTheWeek;
